if (!customElements.get("table-popup")) {
  class TablePopup extends HTMLElement {
    constructor() {
      super();
      this.tableSection = this.closest('.table-section-container');
      this.tablePopupButtons = this.tableSection.querySelectorAll(".custom-filter-value a");
      this.closeButton = this.querySelector(".popup-close-button");
      this.popupWrapper = this;
      this.tablePopupWrappers = this.querySelectorAll(".popup-content-items-wrapper");
      this.showPopup = this.showPopup.bind(this);
      this.hidePopup = this.hidePopup.bind(this);
      this.init();
    }
    init() {
      if (this.tablePopupButtons) {
        this.tablePopupButtons.forEach((element) => {
          element.addEventListener("click", this.showPopup);
        });
      }
      if (this.closeButton) {
        this.closeButton.addEventListener("click", this.hidePopup);
      }
      if (this.popupWrapper) {
        this.popupWrapper.addEventListener("click", (event) => {
          if (!event.target.closest(".table-content-popup-container")) {
            this.hidePopup();
          }
        });
      }
    }
    showPopup(event) {
      const anchorElement = event?.target;
      event.preventDefault();
      document.body.classList.add('body-overflow');
      const closestRow = anchorElement?.closest(".custom-filter-value");
      const index = closestRow?.dataset.index;
      console.log(anchorElement, index, closestRow)
      const activePopupContent = this.querySelector(`#table-popup-${index}`);
      if (activePopupContent) {
        activePopupContent.classList.remove("hidden");
      }
      if (this.popupWrapper) {
        this.popupWrapper.classList.add("active");
      } else {
        console.error("Error: Popup wrapper element not found.");
      }
    }
    hidePopup() {
      this.tablePopupWrappers?.forEach((eachWrapper) =>
        eachWrapper.classList.add("hidden")
      );
      document.body.classList.remove('body-overflow');
      if (this.popupWrapper) {
        this.popupWrapper.classList.remove("active");
      } else {
        console.error("Error: Popup wrapper element not found.");
      }
    }
  }

  customElements.define("table-popup", TablePopup);
}
